module.exports = __webpack_public_path__ + "img/gabriel-hair-spa.9fcf2eb4.jpg";